const Utils = {
  // --------------------------------
  //  Parse a url and break it into resource, id and verb
  // --------------------------------
  parseRequestURL: () => {
    let url = location.hash.slice(1).toLowerCase() || "/";
   
  
    let request = {
      resource: null,
      id: null,
      verb: null,
      query: {},
    };

    let query = url.split("?");
    if (query && query.length > 0) {
      url = query[0];
      for (let index = 1; index < query.length; index++) {
        const element = query[index];
        const key = element.split('=')[0];
        const value = element.split('=')[1];

        request.query[key] = value;
      }
    }
    let r = url.split("/");
    request.resource = r[1];
    request.id = r[2];
    request.verb = r[3];

    return request;
  },

  // --------------------------------
  //  Simple sleep implementation
  // --------------------------------
  parseJwt: (token) => {
    if (!token) return {};
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(jsonPayload);
  },
  sleep: (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  },
};

export default Utils;
